/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * PepsiCo Geospatial UAV API
 * OpenAPI spec version: 0.1.0
 */
import { useMutation, useQuery } from "@tanstack/react-query";
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";

import type {
  DeleteGrowerGeoParams,
  GetGrowersGeoByLocationParams,
  GrowerGeoCreate,
  GrowerGeoResponse,
  GrowerGeoUpdate,
  HTTPValidationError,
} from "../model";

const withQueryKey = <T extends object, K>(
  query: T,
  queryKey: K,
): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === "queryKey") continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

export type getGrowersGeoByLocationResponse200 = {
  data: GrowerGeoResponse[];
  status: 200;
};

export type getGrowersGeoByLocationResponse422 = {
  data: HTTPValidationError;
  status: 422;
};

export type getGrowersGeoByLocationResponseSuccess =
  getGrowersGeoByLocationResponse200 & {
    headers: Headers;
  };
export type getGrowersGeoByLocationResponseError =
  getGrowersGeoByLocationResponse422 & {
    headers: Headers;
  };

export type getGrowersGeoByLocationResponse =
  getGrowersGeoByLocationResponseSuccess | getGrowersGeoByLocationResponseError;

export const getGetGrowersGeoByLocationUrl = (
  params?: GetGrowersGeoByLocationParams,
) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : String(value));
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/growers-geo/?${stringifiedParams}`
    : `/api/growers-geo/`;
};

/**
 * @summary List grower boundaries; location_uuid filter is optional
 */
export const getGrowersGeoByLocation = async (
  params?: GetGrowersGeoByLocationParams,
  options?: RequestInit,
): Promise<getGrowersGeoByLocationResponse> => {
  const res = await fetch(getGetGrowersGeoByLocationUrl(params), {
    ...options,
    method: "GET",
  });

  const body = [204, 205, 304].includes(res.status) ? null : await res.text();

  const data: getGrowersGeoByLocationResponse["data"] = body
    ? JSON.parse(body)
    : {};
  return {
    data,
    status: res.status,
    headers: res.headers,
  } as getGrowersGeoByLocationResponse;
};

export const getGetGrowersGeoByLocationQueryKey = (
  params?: GetGrowersGeoByLocationParams,
) => {
  return [`/api/growers-geo/`, ...(params ? [params] : [])] as const;
};

export const getGetGrowersGeoByLocationQueryOptions = <
  TData = Awaited<ReturnType<typeof getGrowersGeoByLocation>>,
  TError = HTTPValidationError,
>(
  params?: GetGrowersGeoByLocationParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getGrowersGeoByLocation>>,
        TError,
        TData
      >
    >;
    fetch?: RequestInit;
  },
) => {
  const { query: queryOptions, fetch: fetchOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetGrowersGeoByLocationQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getGrowersGeoByLocation>>
  > = ({ signal }) =>
    getGrowersGeoByLocation(params, { signal, ...fetchOptions });

  return {
    queryKey,
    queryFn,
    staleTime: 10000,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getGrowersGeoByLocation>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetGrowersGeoByLocationQueryResult = NonNullable<
  Awaited<ReturnType<typeof getGrowersGeoByLocation>>
>;
export type GetGrowersGeoByLocationQueryError = HTTPValidationError;

export function useGetGrowersGeoByLocation<
  TData = Awaited<ReturnType<typeof getGrowersGeoByLocation>>,
  TError = HTTPValidationError,
>(
  params: undefined | GetGrowersGeoByLocationParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getGrowersGeoByLocation>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getGrowersGeoByLocation>>,
          TError,
          Awaited<ReturnType<typeof getGrowersGeoByLocation>>
        >,
        "initialData"
      >;
    fetch?: RequestInit;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetGrowersGeoByLocation<
  TData = Awaited<ReturnType<typeof getGrowersGeoByLocation>>,
  TError = HTTPValidationError,
>(
  params?: GetGrowersGeoByLocationParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getGrowersGeoByLocation>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getGrowersGeoByLocation>>,
          TError,
          Awaited<ReturnType<typeof getGrowersGeoByLocation>>
        >,
        "initialData"
      >;
    fetch?: RequestInit;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetGrowersGeoByLocation<
  TData = Awaited<ReturnType<typeof getGrowersGeoByLocation>>,
  TError = HTTPValidationError,
>(
  params?: GetGrowersGeoByLocationParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getGrowersGeoByLocation>>,
        TError,
        TData
      >
    >;
    fetch?: RequestInit;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary List grower boundaries; location_uuid filter is optional
 */

export function useGetGrowersGeoByLocation<
  TData = Awaited<ReturnType<typeof getGrowersGeoByLocation>>,
  TError = HTTPValidationError,
>(
  params?: GetGrowersGeoByLocationParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getGrowersGeoByLocation>>,
        TError,
        TData
      >
    >;
    fetch?: RequestInit;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetGrowersGeoByLocationQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

export type createGrowerGeoResponse200 = {
  data: GrowerGeoResponse;
  status: 200;
};

export type createGrowerGeoResponse422 = {
  data: HTTPValidationError;
  status: 422;
};

export type createGrowerGeoResponseSuccess = createGrowerGeoResponse200 & {
  headers: Headers;
};
export type createGrowerGeoResponseError = createGrowerGeoResponse422 & {
  headers: Headers;
};

export type createGrowerGeoResponse =
  createGrowerGeoResponseSuccess | createGrowerGeoResponseError;

export const getCreateGrowerGeoUrl = () => {
  return `/api/growers-geo/`;
};

/**
 * @summary Create Grower Geo Route
 */
export const createGrowerGeo = async (
  growerGeoCreate: GrowerGeoCreate,
  options?: RequestInit,
): Promise<createGrowerGeoResponse> => {
  const res = await fetch(getCreateGrowerGeoUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(growerGeoCreate),
  });

  const body = [204, 205, 304].includes(res.status) ? null : await res.text();

  const data: createGrowerGeoResponse["data"] = body ? JSON.parse(body) : {};
  return {
    data,
    status: res.status,
    headers: res.headers,
  } as createGrowerGeoResponse;
};

export const getCreateGrowerGeoMutationOptions = <
  TError = HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createGrowerGeo>>,
    TError,
    { data: GrowerGeoCreate },
    TContext
  >;
  fetch?: RequestInit;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createGrowerGeo>>,
  TError,
  { data: GrowerGeoCreate },
  TContext
> => {
  const mutationKey = ["createGrowerGeo"];
  const { mutation: mutationOptions, fetch: fetchOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, fetch: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createGrowerGeo>>,
    { data: GrowerGeoCreate }
  > = (props) => {
    const { data } = props ?? {};

    return createGrowerGeo(data, fetchOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateGrowerGeoMutationResult = NonNullable<
  Awaited<ReturnType<typeof createGrowerGeo>>
>;
export type CreateGrowerGeoMutationBody = GrowerGeoCreate;
export type CreateGrowerGeoMutationError = HTTPValidationError;

/**
 * @summary Create Grower Geo Route
 */
export const useCreateGrowerGeo = <
  TError = HTTPValidationError,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof createGrowerGeo>>,
      TError,
      { data: GrowerGeoCreate },
      TContext
    >;
    fetch?: RequestInit;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof createGrowerGeo>>,
  TError,
  { data: GrowerGeoCreate },
  TContext
> => {
  return useMutation(getCreateGrowerGeoMutationOptions(options), queryClient);
};
export type updateGrowerGeoBoundaryResponse200 = {
  data: GrowerGeoResponse;
  status: 200;
};

export type updateGrowerGeoBoundaryResponse422 = {
  data: HTTPValidationError;
  status: 422;
};

export type updateGrowerGeoBoundaryResponseSuccess =
  updateGrowerGeoBoundaryResponse200 & {
    headers: Headers;
  };
export type updateGrowerGeoBoundaryResponseError =
  updateGrowerGeoBoundaryResponse422 & {
    headers: Headers;
  };

export type updateGrowerGeoBoundaryResponse =
  updateGrowerGeoBoundaryResponseSuccess | updateGrowerGeoBoundaryResponseError;

export const getUpdateGrowerGeoBoundaryUrl = (growerGeoId: number) => {
  return `/api/growers-geo/${growerGeoId}`;
};

/**
 * @summary Update Grower Geo Boundary Route
 */
export const updateGrowerGeoBoundary = async (
  growerGeoId: number,
  growerGeoUpdate: GrowerGeoUpdate,
  options?: RequestInit,
): Promise<updateGrowerGeoBoundaryResponse> => {
  const res = await fetch(getUpdateGrowerGeoBoundaryUrl(growerGeoId), {
    ...options,
    method: "PATCH",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(growerGeoUpdate),
  });

  const body = [204, 205, 304].includes(res.status) ? null : await res.text();

  const data: updateGrowerGeoBoundaryResponse["data"] = body
    ? JSON.parse(body)
    : {};
  return {
    data,
    status: res.status,
    headers: res.headers,
  } as updateGrowerGeoBoundaryResponse;
};

export const getUpdateGrowerGeoBoundaryMutationOptions = <
  TError = HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateGrowerGeoBoundary>>,
    TError,
    { growerGeoId: number; data: GrowerGeoUpdate },
    TContext
  >;
  fetch?: RequestInit;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateGrowerGeoBoundary>>,
  TError,
  { growerGeoId: number; data: GrowerGeoUpdate },
  TContext
> => {
  const mutationKey = ["updateGrowerGeoBoundary"];
  const { mutation: mutationOptions, fetch: fetchOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, fetch: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateGrowerGeoBoundary>>,
    { growerGeoId: number; data: GrowerGeoUpdate }
  > = (props) => {
    const { growerGeoId, data } = props ?? {};

    return updateGrowerGeoBoundary(growerGeoId, data, fetchOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateGrowerGeoBoundaryMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateGrowerGeoBoundary>>
>;
export type UpdateGrowerGeoBoundaryMutationBody = GrowerGeoUpdate;
export type UpdateGrowerGeoBoundaryMutationError = HTTPValidationError;

/**
 * @summary Update Grower Geo Boundary Route
 */
export const useUpdateGrowerGeoBoundary = <
  TError = HTTPValidationError,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof updateGrowerGeoBoundary>>,
      TError,
      { growerGeoId: number; data: GrowerGeoUpdate },
      TContext
    >;
    fetch?: RequestInit;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof updateGrowerGeoBoundary>>,
  TError,
  { growerGeoId: number; data: GrowerGeoUpdate },
  TContext
> => {
  return useMutation(
    getUpdateGrowerGeoBoundaryMutationOptions(options),
    queryClient,
  );
};
export type deleteGrowerGeoResponse200 = {
  data: GrowerGeoResponse;
  status: 200;
};

export type deleteGrowerGeoResponse422 = {
  data: HTTPValidationError;
  status: 422;
};

export type deleteGrowerGeoResponseSuccess = deleteGrowerGeoResponse200 & {
  headers: Headers;
};
export type deleteGrowerGeoResponseError = deleteGrowerGeoResponse422 & {
  headers: Headers;
};

export type deleteGrowerGeoResponse =
  deleteGrowerGeoResponseSuccess | deleteGrowerGeoResponseError;

export const getDeleteGrowerGeoUrl = (
  growerGeoId: number,
  params?: DeleteGrowerGeoParams,
) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : String(value));
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/growers-geo/${growerGeoId}?${stringifiedParams}`
    : `/api/growers-geo/${growerGeoId}`;
};

/**
 * Soft-clear the boundary polygon and record ``user_id`` (row is kept).
 * @summary Delete Grower Geo Route
 */
export const deleteGrowerGeo = async (
  growerGeoId: number,
  params?: DeleteGrowerGeoParams,
  options?: RequestInit,
): Promise<deleteGrowerGeoResponse> => {
  const res = await fetch(getDeleteGrowerGeoUrl(growerGeoId, params), {
    ...options,
    method: "DELETE",
  });

  const body = [204, 205, 304].includes(res.status) ? null : await res.text();

  const data: deleteGrowerGeoResponse["data"] = body ? JSON.parse(body) : {};
  return {
    data,
    status: res.status,
    headers: res.headers,
  } as deleteGrowerGeoResponse;
};

export const getDeleteGrowerGeoMutationOptions = <
  TError = HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteGrowerGeo>>,
    TError,
    { growerGeoId: number; params?: DeleteGrowerGeoParams },
    TContext
  >;
  fetch?: RequestInit;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteGrowerGeo>>,
  TError,
  { growerGeoId: number; params?: DeleteGrowerGeoParams },
  TContext
> => {
  const mutationKey = ["deleteGrowerGeo"];
  const { mutation: mutationOptions, fetch: fetchOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, fetch: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteGrowerGeo>>,
    { growerGeoId: number; params?: DeleteGrowerGeoParams }
  > = (props) => {
    const { growerGeoId, params } = props ?? {};

    return deleteGrowerGeo(growerGeoId, params, fetchOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteGrowerGeoMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteGrowerGeo>>
>;

export type DeleteGrowerGeoMutationError = HTTPValidationError;

/**
 * @summary Delete Grower Geo Route
 */
export const useDeleteGrowerGeo = <
  TError = HTTPValidationError,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof deleteGrowerGeo>>,
      TError,
      { growerGeoId: number; params?: DeleteGrowerGeoParams },
      TContext
    >;
    fetch?: RequestInit;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof deleteGrowerGeo>>,
  TError,
  { growerGeoId: number; params?: DeleteGrowerGeoParams },
  TContext
> => {
  return useMutation(getDeleteGrowerGeoMutationOptions(options), queryClient);
};
